import { render, staticRenderFns } from "./ChainForm.vue?vue&type=template&id=bc96bee8&scoped=true&"
import script from "./ChainForm.vue?vue&type=script&lang=js&"
export * from "./ChainForm.vue?vue&type=script&lang=js&"
import style0 from "./ChainForm.vue?vue&type=style&index=0&id=bc96bee8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc96bee8",
  null
  
)

export default component.exports